import React from "react";
import { CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useErrorToast } from "../hooks/useErrorToast";
import { useToleranceChanges } from "../hooks/useToleranceChanges";
import { percent } from "../utils/closeOutFormat";
import { formatInstant } from "../utils/formatInstant";
import { L_TOLERANCE } from "./closeOutSchemas";

const L = `${L_TOLERANCE}.history`;

const ToleranceChangeList: React.FC<{ operationId: string; shipperCode: string }> = ({
  operationId,
  shipperCode,
}) => {
  const { t } = useTranslation();
  const changes = useToleranceChanges(operationId, true);
  useErrorToast(changes.isError, t(`${L}.load-failed`));

  if (changes.isLoading) {
    return <CircularProgress aria-label={t(`${L}.title`)} />;
  }
  const rows = (changes.data?.changes ?? []).filter(
    (row) => row.shipperCompanyCode === shipperCode,
  );
  if (rows.length === 0) {
    return (
      <Typography variant="body2" data-testid="tolerance-history-empty">
        {t(`${L}.empty`)}
      </Typography>
    );
  }
  return (
    <table className="w-full text-sm text-left" data-testid="tolerance-history-list">
      <thead>
        <tr>
          <th>{t(`${L}.date`)}</th>
          <th>{t(`${L}.from`)}</th>
          <th>{t(`${L}.to`)}</th>
          <th>{t(`${L}.changed-by`)}</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={`${row.changedAt}-${row.oldTolerancePct}-${row.newTolerancePct}`}>
            <td>{formatInstant(row.changedAt)}</td>
            <td>{percent(row.oldTolerancePct)}</td>
            <td>{percent(row.newTolerancePct)}</td>
            <td>{row.changedBy ?? t(`${L}.operations-department`)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ToleranceChangeList;
